import type { MockDatabase } from '../db/schema'

export const cloneDb = (db: MockDatabase): MockDatabase =>
  JSON.parse(JSON.stringify(db)) as MockDatabase
